import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import styled from 'styled-components';
import { styleUtils } from '../../utils';

import { View } from '../View';

import styles from './styles';
import FORMAT_PATTERNS from "../../constants/format";

const { style } = styleUtils;

const SIZES = ['small', 'normal', 'large', 'xlarge', 'title', 'placeholder'];

const Container = styled(View)(styles.container);
const COMPONENTS = {
  small: style('span', styles.small),
  normal: style('span', styles.normal),
  large: style('span', styles.large),
  xlarge: style('span', styles.xlarge),
  title: style('span', styles.title),
  placeholder: style('span', styles.placeholder)
};

const Text = ({
  size,
  children,
  align,
  debug,
  required,
  sublabel,
  format,
  ...restOfProps
}) => {
  const Component = COMPONENTS[size];
  let text = required ? `${children} *` : children;
  text = format ? numeral(text).format(format) : text;

  if (align)
    return (
      <Container align={align}>
        <Component {...restOfProps}>{text}</Component>
      </Container>
    );
  return <Component {...restOfProps}>{text}</Component>;
};

Text.propTypes = {
  size: PropTypes.oneOf(SIZES),
  color: PropTypes.string,
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.string,
  font: PropTypes.string,
  required: PropTypes.bool,
  format: PropTypes.oneOf(Object.values(FORMAT_PATTERNS))
};

Text.defaultProps = {
  size: 'normal',
  required: false,
  uppercase: false
};

Text.displayName = 'Text';

export default Text;
